// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3QyFm","log":"ModalInventoryLogs_log__19V1s","date":"ModalInventoryLogs_date__1ZutL","userName":"ModalInventoryLogs_userName__1pzTg"};